import RootState from 'typings/RootState'
import { Event } from 'features/types/event'
import { Data } from './types';

export const selectData = (state: RootState): Data => state.cmpjZoneReport.data
export const selectEvent = (state: RootState): Event =>
  state.cmpjZoneReport.event
